module.exports = __webpack_public_path__ + "static/img/yuyan.0df62189.svg";